import { render, staticRenderFns } from "./DetalheOfertaTitulo.vue?vue&type=template&id=ccaaed36&scoped=true"
import script from "./DetalheOfertaTitulo.vue?vue&type=script&lang=js"
export * from "./DetalheOfertaTitulo.vue?vue&type=script&lang=js"
import style0 from "./DetalheOfertaTitulo.vue?vue&type=style&index=0&id=ccaaed36&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccaaed36",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/thales/Recuperi/recuperi/recuperi-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ccaaed36')) {
      api.createRecord('ccaaed36', component.options)
    } else {
      api.reload('ccaaed36', component.options)
    }
    module.hot.accept("./DetalheOfertaTitulo.vue?vue&type=template&id=ccaaed36&scoped=true", function () {
      api.rerender('ccaaed36', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DetalheOfertaTitulo.vue"
export default component.exports